<template>
  <div class="d-flex footer content-container">
    <!-- Lewa kolumna: miejsce na filtry, pozostawione puste dla spójności układu -->
    <div class="filters-container"></div>
    <!-- Główna zawartość stopki, rozmieszczona w poziomie -->
    <div class="d-flex content-wrap justify-content-between">
      <!-- Lewy baner, np. logo partnera lub projektu -->
      <div class="banners">
        <img v-if="version.startsWith('SG')" src="../assets/posg.png" alt="posg" style="height: 120px; width: auto;"/>
        <img v-else src="../assets/gddkia.png" alt="gddkia" style="height: 80px; width: auto;" />
      </div>
      <!-- Środkowa informacja: prawa autorskie i właściciel -->
      <div class="info">{{ t('all-rights-reserved') }}. VS Tech PL Sp. z o.o.</div>
      <!-- Prawa strona: wersja aplikacji (pobierana z env) -->
      <div class="info">{{ t('version') }} {{ version }}</div>
    </div>
  </div>
</template>

<script>
export default {
  // Komponent stopki wyświetlający wersję oraz dane o prawach autorskich
  data() {
    return {
      // Wersja aplikacji zdefiniowana w .env lub w package.json (przez build)
      version: process.env.VUE_APP_VERSION_NAME
    };
  }
}
</script>

<style scoped>
.content-container {
  background-color: #f5f4f2;
}

.content-container > div {
  min-height: 80px;
}

.filters-container {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

/* .banners {
  margin: 10px 35px;
} */

.info {
  font-size: 11px;
  margin: 33px 55px 0 0;
  /* padding-top: 2.5rem; */
}
</style>
